import {Link} from "react-router-dom";
import {useGetMarketplaceSuppliersQuery} from "../../store/services/publicApi";
import ComingSoon from "./ComingSoon";

type Supplier = {
    id: string;
    name: string;
    description?: string;
    listingCount: number;
    location?: {country?: {name?: string}; region?: {name?: string}};
};

/**
 * Companies that have at least one published listing.
 * A supplier is that company, not a separate record.
 */
export default function SuppliersPage() {
    const {data, isLoading, isError} = useGetMarketplaceSuppliersQuery(undefined);

    if (isError) {
        return (
            <ComingSoon
                title="Suppliers Directory"
                description="We're building a directory of verified energy equipment suppliers across Africa. Check back soon."
                icon="ni ni-shop"
            />
        );
    }

    const suppliers = (data || []) as Supplier[];

    return (
        <section className="oec-section" style={{paddingTop: "7rem", minHeight: "70vh"}}>
            <div className="oec-section-inner">
                <h1 className="oec-section-title">Suppliers</h1>
                <p className="oec-section-subtitle">
                    Verified companies with products or services in the Energy Marketplace.
                </p>

                {isLoading && <p className="oec-section-subtitle">Loading suppliers...</p>}

                {!isLoading && suppliers.length === 0 && (
                    <p className="oec-section-subtitle" style={{marginTop: "1.5rem"}}>
                        No suppliers have published a product yet.
                    </p>
                )}

                <div className="oec-card-grid oec-card-grid-roomy" style={{marginTop: "1.25rem"}}>
                    {suppliers.map((supplier) => {
                        const place = [supplier.location?.region?.name, supplier.location?.country?.name]
                            .filter(Boolean)
                            .join(", ");
                        return (
                            <article key={supplier.id} className="oec-company-card">
                                <h2 className="oec-cat-card-title">{supplier.name}</h2>
                                {supplier.description && (
                                    <p className="oec-company-type">
                                        <i className="fas fa-industry"/>
                                        <span>{supplier.description}</span>
                                    </p>
                                )}
                                {place && (
                                    <p className="oec-company-meta">
                                        <i className="fas fa-map-marker-alt"/>
                                        <span>{place}</span>
                                    </p>
                                )}
                                <p className="oec-company-meta">
                                    <i className="fas fa-box"/>
                                    <span>{supplier.listingCount} published {supplier.listingCount === 1 ? "listing" : "listings"}</span>
                                </p>
                                <Link className="oec-card-btn" to={`/marketplace?supplier=${encodeURIComponent(supplier.name)}`}>
                                    View products <i className="fas fa-arrow-right"/>
                                </Link>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
